export const TASKS_LOADED = 'TASKS_LOADED';
export const TASKS_REQUEST_TASK = 'TASKS_REQUEST_TASK';
export const TASKS_ADD_TASK = 'TASKS_ADD_TASK';
export const TASKS_CLEAR = 'TASKS_CLEAR';
export const TASKS_UPDATE_CURRENT_TASK = 'TASKS_UPDATE_CURRENT_TASK';
